import { Company } from '@/modules/company/entities/interfaces/company';
import SelectCompany, { SelectCompanyProps } from '@/modules/company/views/selectCompany/selectCompany';
import React, { useMemo } from 'react';

import Space from '@/components/space';
import { DataSelectType } from '@/shared/entities/types';
import { Button } from 'vkit/lib/components';
import { Grid, Row } from 'vkit/lib/context';

interface SwitchProps extends SelectCompanyProps {
  handleClose: () => void;
  companies?: Company[];
}

const Switch: React.FC<SwitchProps> = ({
  handleClose,
  companies,
  selectedCompanyId,
  onChangeSelectedCompany,
}) => {
  const dataCompanies = useMemo((): DataSelectType[] | undefined => {
    if (companies) {
      return companies.map((company) => ({
        ...company,
        text: company.name,
        value: company.id || '',
      }));
    }
  }, [companies]);

  return (
    <Grid row alignItems='center'>
      <Row style={{ padding: 0, width: 400 }}>
        <SelectCompany
          selectedCompanyId={selectedCompanyId}
          onChangeSelectedCompany={onChangeSelectedCompany}
          data={dataCompanies}
        />
      </Row>
      <Space />
      <Button
        color='colorDefault'
        icon='close-outline'
        iconColor='colorDefault'
        invertColor
        onClick={() => handleClose()}
        size='larger'
      />
    </Grid>
  );
};

export default Switch;
